import React from 'react';
import './App.css';
import EmailForm from './components/EmailForm';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <div className="container">
          <div className="welcome-section">
            <h1>AI-агент по формированию писем и служебных записок по внутреннему стандарту</h1>
            <p>Заполните поля ниже и нажмите на "Сформировать письмо"</p>
          </div>
          <EmailForm />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;